import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import router from "./router";
import VueI18n from "vue-i18n";
import langEn from "./locale/lang/en";
import store from "@/vuex/store";
import "element-ui/lib/theme-chalk/index.css";
// sentry.io
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
// google analytics
import VueAnalytics from "vue-analytics";
// translation config
Vue.use(VueI18n);
let messages = {
  en: {
    ...langEn
  }
};

const i18n = new VueI18n({
  locale: "en", // set locale
  messages // set locale messages
});
Vue.config.productionTip = false;
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

// sentry.io
if (process.env.VUE_APP_SENTRY_IO_DNS) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_IO_DNS,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

// google analytics
if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS,
    router
  });
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  components: { App },
  render: h => h(App)
}).$mount("#app");

export { i18n };
